import React, { ReactNode } from 'react'
import styled from '~/app/components/styled'
import { CANCELLATION_STATUS, statusToString } from '~/app/utils/OrderListUtils'
import { LineClamp } from '~/app/components/styles/mixin'
import { Typography } from '@yanolja-rnd/ya-com-core'

/**
 * RefundCardTitle component
 * author: soojin.oh
 */

// type definitions
type RefundCardTitleProps = {
  representativeGoodsName: string
  itemCount: number
  status: CANCELLATION_STATUS
  date: string
  rightAppended?: ReactNode
}

// styled components
const Container = styled.div`
  padding: 1.4rem 1.6rem 0;
`
const Status = styled.div`
  ${Typography('badge').bold};
  padding: 0.2rem 0.6rem;
  border-radius: 0.4rem;
  margin-bottom: 0.4rem;
  display: inline-block;

  &.cancel-requested {
    color: ${({ theme }) => theme.color.white};
    background: ${({ theme }) => theme.color.gray900};
  }

  &.cancel-completed {
    color: ${({ theme }) => theme.color.white};
    background: ${({ theme }) => theme.color.gray400};
  }
`
const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`

const Title = styled.div`
  color: ${({ theme }) => theme.color.gray900};
  ${LineClamp(1)};
  max-height: 2.1rem;
  ${Typography('body1.multiline').regular};
`

const SubTitle = styled.div`
  ${Typography('body1').regular};
  color: ${({ theme }) => theme.color.gray900};
`

const Date = styled.div`
  color: ${({ theme }) => theme.color.gray600};
  ${Typography('body2.multiline').regular};
`

// RefundCardTitle component
const RefundCardTitle: React.FunctionComponent<RefundCardTitleProps> = function ({
  representativeGoodsName,
  itemCount,
  status,
  date,
  rightAppended,
}) {
  return (
    <Container>
      <div>
        <Status className={statusToString(status)}>{status}</Status>
        <TitleWrapper>
          <Title>{representativeGoodsName}</Title>
          <div>{rightAppended}</div>
        </TitleWrapper>
        {itemCount > 1 && <SubTitle>외 {itemCount - 1}건</SubTitle>}
        <Date>{date}</Date>
      </div>
    </Container>
  )
}

export default RefundCardTitle
